import {} from "../env/index.js";
import {} from "../mod/index.js";
import {} from "../parameter/index.js";
import {} from "./evaluate.js";
import { evaluateOne } from "./evaluateOne.js";
export function evaluateParameters(mod, env, parameterExps, options) {
    return parameterExps.map(({ name, t, isPrincipal }) => ({
        name,
        t: evaluateOne(mod, env, t, options),
        isPrincipal,
    }));
}
//# sourceMappingURL=evaluateParameters.js.map